import React, { useState } from 'react';
import { User, Settings, LogOut, Bell, ChevronDown } from 'lucide-react';
import './Header.css';


const NameAvatar = ({ name }) => {
  const getInitials = (name) => {
    const names = name.split(' ');
    if (names.length >= 2) {
      return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
    }
    return name[0].toUpperCase();
  };

  const getHSLColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = hash % 360;
    return `hsl(${hue}, 65%, 60%)`;
  };

  const initials = getInitials(name);
  const backgroundColor = getHSLColor(name);

  return (
    <div className="nameAvatar" style={{ backgroundColor }}>
      {initials}
    </div>
  );
};

// <span>
//        <svg width="63" height="34" viewBox="0 0 63 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.9175 17.0027C24.1266 17.5541 25.2275 18.3701 26.1292 19.4448C26.7213 20.1504 27.1887 20.9213 27.5341 21.7317C28.0668 20.1109 28.3551 18.3802 28.3551 16.5834C28.3551 15.2613 28.199 13.975 27.9044 12.7418C27.6166 13.2727 27.2722 13.7816 26.8704 14.2605C25.7875 15.5509 24.4174 16.4685 22.9175 17.0027ZM20.5884 30.5922L21.7374 29.628C23.9311 27.7873 24.281 24.5788 22.5161 22.4754C21.7042 21.5078 20.5838 20.9403 19.397 20.789C17.9151 23.4443 15.0763 25.2437 11.8257 25.2437H3.93452C1.76114 25.2437 0 27.0061 0 29.1775C0 29.2785 0.00315928 29.3764 0.0126362 29.4728C0.162688 31.5083 1.86222 33.1112 3.93452 33.1112H11.8241C15.0409 33.1112 18.0461 32.1878 20.5884 30.5922ZM23.2584 11.2285C22.3446 12.3174 21.0408 12.8995 19.6912 12.9524C18.3153 9.98421 15.3067 7.92001 11.8257 7.92001H3.93452C1.76272 7.92001 0 6.15922 0 3.98626C0 3.88677 0.00315928 3.78728 0.0126362 3.69095C0.162688 1.65854 1.86064 0.0556641 3.93452 0.0556641H11.8257C15.2347 0.0556641 18.4057 1.09267 21.04 2.86773L22.4797 4.07579C24.6734 5.9165 25.0227 9.12574 23.2584 11.2285Z" fill="#1F2937"></path><path d="M34.0004 16.5279C34.0004 7.41441 41.4161 0.00012207 50.5314 0.00012207H58.4209C60.4932 0.00012207 62.1928 1.603 62.3428 3.63857C62.3523 3.7349 62.3555 3.83281 62.3555 3.93388C62.3555 6.10526 60.5943 7.86763 58.4209 7.86763H50.5298C45.7534 7.86763 41.8663 11.7524 41.8663 16.5295C41.8663 21.3049 45.7534 25.1913 50.5298 25.1913H58.4209C60.5928 25.1913 62.3555 26.9521 62.3555 29.1251C62.3555 29.2246 62.3523 29.324 62.3428 29.4204C62.1928 31.4528 60.4948 33.0557 58.4209 33.0557H50.5298C41.4145 33.0557 34.0004 25.6414 34.0004 16.5279Z" fill="#1F2937"></path><path d="M62.0696 24.4503C62.248 24.5861 62.4123 24.744 62.5576 24.9146C62.4644 24.8356 62.3728 24.7535 62.2859 24.6666L62.0696 24.4503Z" fill="#1F2937"></path><path d="M62.2859 8.38708C62.3759 8.29707 62.4675 8.21179 62.5654 8.13283C62.4154 8.31128 62.2448 8.47236 62.0616 8.61133L62.2859 8.38708Z" fill="#1F2937"></path><path d="M39.6533 16.5277C39.6533 8.91125 45.8497 2.71769 53.466 2.71769H60.0619C60.9496 2.71769 61.752 3.06827 62.3443 3.63835C62.3538 3.73468 62.3569 3.83259 62.3569 3.93366C62.3569 6.10504 60.5958 7.86741 58.4224 7.86741H50.5313C45.7549 7.86741 41.8677 11.7522 41.8677 16.5293C41.8677 21.3047 45.7549 25.1911 50.5313 25.1911H58.4208C60.5926 25.1911 62.3554 26.9519 62.3554 29.1248C62.3554 29.2243 62.3522 29.3238 62.3427 29.4202C61.7504 29.9902 60.948 30.3408 60.0604 30.3408H53.466C45.8497 30.3377 39.6533 24.1441 39.6533 16.5277Z" fill="#1F2937"></path><rect y="24.0557" width="14" height="8" rx="4" transform="rotate(-90 0 24.0557)" fill="#1F2937"></rect><rect x="15" y="11.0557" width="29" height="12" rx="6" fill="white" stroke="#1F2937" stroke-width="4"></rect><line x1="29.5" y1="9.05566" x2="29.5" y2="25.0557" stroke="white" stroke-width="4"></line><rect x="24" y="16.0557" width="11" height="2" rx="1" fill="#1F2937" stroke="#1F2937" stroke-width="2"></rect></svg>
//         </span>
        // <span className="heading mainlogoheading">Quora Traffic Ops</span>

const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const storedUser = localStorage.getItem("user");
  const userData = storedUser ? JSON.parse(storedUser) : null;
  const userEmail = userData?.email || "user@example.com";

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

{/* <div className="logoDiv">
</div> */}



const handleLogout = () => {
  localStorage.clear();
  window.location.reload();
};

  return (
    <div className="header">
    
      <img 
  src="/3.png" 
  alt="Quora Traffic Ops Logo" 
  style={{ height: '100px', width: 'auto', marginLeft: '-70px' }}
/>  
      
      <div className="userSection">
        {/* <div className="notificationBell">
          <Bell size={20} />
          <span className="notificationBadge">3</span>
        </div> */}

        <div className="userContainer">
          <div className="userProfile" onClick={toggleDropdown}>
            <div className="avatarContainer">
              <NameAvatar name={userEmail} />
              <div className="onlineStatus"></div>
            </div>
            
            <div className="userInfo">
              <span className="userName">{userEmail}</span>
            </div>

            <ChevronDown 
              size={20} 
              className={`dropdownIcon ${isDropdownOpen ? 'rotate' : ''}`}
            />
          </div>

          {isDropdownOpen && (
            <div className="dropdownMenu">
              <div className="dropdownHeader">
                <span className="welcomeText">Welcome!</span>
                <span className="userEmail">{userEmail}</span>
              </div>
              
              <div className="dropdownDivider"></div>
              
              <button className="dropdownItem">
                <User size={16} />
                <span>Profile</span>
              </button>
              
              <button className="dropdownItem">
                <Settings size={16} />
                <span>Settings</span>
              </button>
              
              <div className="dropdownDivider"></div>
              
              <button className="dropdownItem logoutItem" onClick={handleLogout}>
                <LogOut size={16} />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;